import type { OrgRole } from '@finvox/shared/org';
import { isValidEmail } from '@/lib/emailValidation';

export const ASSIGNABLE_MEMBER_ROLES = ['accountant', 'bookkeeper', 'viewer'] as const satisfies readonly OrgRole[];

export function normalizeMemberEmail(email: string): string {
  return email.trim().toLowerCase();
}

export function assertValidProvisionInput(email: string, password: string): string {
  const normalized = normalizeMemberEmail(email);
  if (!isValidEmail(normalized)) throw new Error('Invalid email');
  if (password.length < 6) throw new Error('Password must be at least 6 characters');
  return normalized;
}

export function assertAssignableRole(role: OrgRole): void {
  if (!ASSIGNABLE_MEMBER_ROLES.includes(role as (typeof ASSIGNABLE_MEMBER_ROLES)[number])) {
    throw new Error('Cannot assign owner role');
  }
}
